import { render, staticRenderFns } from "./CoverageLevels.vue?vue&type=template&id=2dc88bde&"
import script from "./CoverageLevels.vue?vue&type=script&lang=js&"
export * from "./CoverageLevels.vue?vue&type=script&lang=js&"
import style0 from "./CoverageLevels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc88bde')) {
      api.createRecord('2dc88bde', component.options)
    } else {
      api.reload('2dc88bde', component.options)
    }
    module.hot.accept("./CoverageLevels.vue?vue&type=template&id=2dc88bde&", function () {
      api.rerender('2dc88bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/CoverageLevels.vue"
export default component.exports